import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRoller: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconRoller"><Path d="M13 4V6H15.6802L17.1354 13.276C16.1814 13.6803 15.4438 14.4957 15.1449 15.5H8.85506C8.42479 14.0543 7.08551 13 5.5 13C3.567 13 2 14.567 2 16.5C2 18.433 3.567 20 5.5 20C7.08551 20 8.42479 18.9457 8.85506 17.5H15.1449C15.5752 18.9457 16.9145 20 18.5 20C20.433 20 22 18.433 22 16.5C22 14.7825 20.7629 13.3539 19.1312 13.0568L17.3198 4H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRoller;
